import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';

@jsonObject
export class PublicBrandCollectionItemResponse {
  @jsonMember(String)
  public id!: Guid;

  @jsonMember(String)
  public name!: string;

  @jsonMember(String)
  public slug!: string;

  @jsonMember(MultimediaResponse)
  public logo!: MultimediaResponse;
}
